export enum CameraStrategy {
    JumpTo = 'jumpTo',
    FlyTo = 'flyTo'
}
